import useSWR, { mutate } from 'swr'
import useSWRMutation from 'swr/mutation'

import {
  bookmarkDocument,
  getAllDocuments,
  getBookmarkedDocuments,
  getLastDocuments,
  getRelatedDocuments,
  getDocumentById,
  getAllDocumentTypes,
} from '../../api/documents'
import useSWRImmutable from 'swr/immutable'

const CACHE_KEYS = {
  BASE: 'documents',
  ALL: 'all',
  LAST: 'last',
  RECOMMENDED: 'recommended',
  RELATED: 'related',
  BOOKMARKED: 'bookmarked',
  TYPES: 'types',
} as const

export const useAllDocuments = () => {
  return useSWR([CACHE_KEYS.BASE, CACHE_KEYS.ALL], () => getAllDocuments())
}

export const useLastDocuments = (maxItems: number) => {
  return useSWR([CACHE_KEYS.BASE, CACHE_KEYS.LAST], () => getLastDocuments(maxItems))
}

export const useRelatedDocuments = (documentId: number, maxItems: number) => {
  return useSWR([CACHE_KEYS.BASE, CACHE_KEYS.RELATED, documentId], () => getRelatedDocuments(documentId, maxItems))
}

export const useDocumentById = (documentId: string) => {
  return useSWR(documentId ? [CACHE_KEYS.BASE, documentId] : null, () => getDocumentById({ id: documentId }))
}

export const useMutateBookmarkDocument = (documentId: string) => {
  return useSWRMutation([CACHE_KEYS.BASE, documentId], bookmarkDocument, {
    onSuccess: async () => {
      await mutate([CACHE_KEYS.BASE, CACHE_KEYS.LAST])
    },
  })
}

export const useBookmarkedDocuments = () => {
  return useSWR([CACHE_KEYS.BASE, CACHE_KEYS.BOOKMARKED], getBookmarkedDocuments)
}

export const useAllDocumentTypes = () => {
  return useSWRImmutable([CACHE_KEYS.BASE, CACHE_KEYS.TYPES], getAllDocumentTypes)
}
